<template>
  <div class="text-left">
    <div v-if="!model.package">
      <b-alert variant="warning" :show="true">
        <strong>We're sorry!</strong>
        Something went wrong.
      </b-alert>
    </div>
    <div v-else-if="getBookingResponse">
      <b-alert variant="success" :show="true">
        <div v-html="successMessage"></div>
      </b-alert>
    </div>
    <b-form @submit.prevent="submit()" v-else>
      <div>
        <div class="mb-3">
          <div class="row">
            <div class="col-md">
              <div class="form-group">
                <label><strong>Intake date:</strong></label>
                <div>
                  {{ model.intakeDate | moment("DD MMM, YYYY") }} (preferred)
                </div>
              </div>
            </div>
            <div class="col-md-8">
              <div class="form-group">
                <label><strong>Package:</strong></label>
                <div>
                  {{ model.package.title_with_code }}
                </div>
              </div>
            </div>
          </div>
          <hr class="mt-0" />
          <p v-html="model.package.description"></p>
          <hr />
        </div>
        <div v-if="model.applicant.fullName != ''">
          <div>
            APPLICANT -
            <strong
              >{{ model.applicant.fullName }}
              <span v-if="model.applicant.studentCode != ''"
                >({{ model.applicant.studentCode }})</span
              ></strong
            >
          </div>
          <hr />
          <div class="row">
            <div class="col-md-6" v-if="model.applicant.emailAddress != ''">
              <div class="form-group">
                <label><strong>Email:</strong></label>
                <div>
                  {{ model.applicant.emailAddress }}
                </div>
              </div>
            </div>
            <div class="col-md-6" v-if="model.applicant.mobilePhone != ''">
              <div class="form-group">
                <label><strong>Contact:</strong></label>
                <div>
                  {{ model.applicant.mobilePhone }}
                </div>
              </div>
            </div>
            <div class="col-md-6" v-if="model.applicant.postalAddress != ''">
              <div class="form-group">
                <label><strong>Postal Address:</strong></label>
                <div>
                  {{ model.applicant.postalAddress }}
                  <span v-if="model.applicant.city != ''">
                    {{ model.applicant.city }}
                    <span v-if="model.applicant.postCode != ''">
                      - {{ model.applicant.postCode }}
                    </span>
                  </span>
                  <span v-if="model.applicant.state != ''">
                    {{ model.applicant.state }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <hr />
        </div>
        <b-form-group id="input-group-1" label-for="input-1">
          <b-form-checkbox
            v-model="model.acceptedToC"
            name="check-button"
            switch
          >
            I read the <a :href="tocUrl">Terms &amp; Conditions</a> carefully
            and accepted
          </b-form-checkbox>
        </b-form-group>

        <b-form-group
          id="input-group-1"
          label-for="input-1"
          v-if="tocRenewalUrl != ''"
        >
          <b-form-checkbox
            v-model="model.acceptedToCRenewal"
            name="check-button"
            switch
          >
            I read the
            <a :href="tocRenewalUrl">Renewal Terms &amp; Conditions</a>
            carefully and accepted
          </b-form-checkbox>
        </b-form-group>
      </div>
      <hr />
      <div class="my-3">
        <div class="row">
          <div class="col-6">
            <h3 v-if="getBooking && false" id="calculatedPrice">
              Total: &euro;{{ getBooking.totalAmount | round }}
            </h3>
          </div>
          <div class="col text-right">
            <b-button
              v-if="getBooking.step > getBooking.firstStep"
              type="button"
              variant="default"
              @click="back()"
              >Back</b-button
            >
            <b-button type="submit" variant="primary">Submit</b-button>
          </div>
        </div>
      </div>
    </b-form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import "../../filters";

export default {
  name: "BookingPreview",
  data() {
    return {
      model: null,
    };
  },
  components: {},
  computed: {
    ...mapGetters(["getSettings", "getBooking", "getBookingResponse"]),
    successMessage() {
      const code = this.getBookingReferenceCode();
      if (code === "") {
        return "";
      }

      return `<strong>Thank you!</strong> We have recieved your booking request. 
        Your booking reference code is <strong>${code}</strong>.
        <p>We'll be back to you soon as possible. 
        Meanwhile, please feel free to contact us if you have any questions.</p>`;
    },
    tocUrl() {
      /*
      return this.model.eu_student
        ? process.env.VUE_APP_EU_TOC_URL
        : process.env.VUE_APP_TOC_URL;
        */

      if (!this.getSettings) return "#";

      return this.model.eu_student
        ? this.getSettings.officialEUToCUrl
        : this.getSettings.officialToCUrl;
    },
    tocRenewalUrl() {
      if (
        !this.getSettings ||
        !this.getSettings.tocRenewalUrl ||
        this.getSettings.tocRenewalUrl == ""
      ) {
        return "";
      }
      
      return this.getSettings.tocRenewalUrl;
    },
  },
  methods: {
    ...mapActions(["saveBooking", "submitBooking", "moveBookingBack"]),
    async submit() {
      let vm = this;

      if (!vm.model.acceptedToC) {
        vm.$swal("Please accept our Terms & Conditions before proceed");
        return false;
      }

      if (vm.tocRenewalUrl && !vm.model.acceptedToCRenewal) {
        vm.$swal("Please accept our Renewal Terms & Conditions before proceed");
        return false;
      }

      vm.saveBooking(vm.model);

      vm.$swal({
        text: "Please wait...",
        icon: "info",
        closeOnClickOutside: false,
        button: false,
      });

      await vm.submitBooking(vm.model);

      vm.$swal.close();

      if (!vm.model.exception && vm.getBookingResponse) {
        vm.$swal({
          title: "Success",
          html: vm.successMessage,
          icon: "success",
        });
      } else {
        vm.$swal({
          title: "Error",
          text: vm.model.exception
            ? vm.model.exception.message
            : "Unexpected error while submitting this request. Please try later or contact us for support.",
          icon: "error",
        });
      }
    },
    save() {
      // save and go to next
      //const thisStep = this.model.step ? this.model.step : 1;
      //if (thisStep > 0) this.model.step = thisStep + 1;
      //this.saveBooking(this.model);
      //return false;
    },
    back() {
      // go back
      //const thisStep = this.model.step ? this.model.step : 1;
      //if (thisStep > 1) this.model.step = thisStep - 1;
      this.saveBooking(this.model);
      this.moveBookingBack();
      return false;
    },
    getBookingReferenceCode() {
      return this.getBookingResponse
        ? this.getBookingResponse.reference_code
        : "";
    },
  },
  created() {
    let vm = this;
    if (vm.getBooking) {
      vm.model = JSON.parse(JSON.stringify(vm.getBooking));
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
